// extracted by mini-css-extract-plugin
export default {"table-auto":"ReportGenerationPage_table-auto__KinXB"};